import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import type { AccreditationVersionsResponse } from '../../_types/settings';

export const getAccreditationVersionsAvailable = async (
  organizationId: string,
  onError?: (errors: ServerErrorResponse) => void
): Promise<AccreditationVersionsResponse> => {
  try {
    const data = await fetcher({
      method: 'get',
      url: `${baseApiUrl()}/awb/accreditation-body/v1/organizations/${organizationId}/accreditation-body-versions/available`,
    });
    return data;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useAccreditationVersionsAvailable(
  organizationId: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<AccreditationVersionsResponse, ServerErrorResponse>(
    ['accreditationVersionsAvailable', organizationId],
    async () => getAccreditationVersionsAvailable(organizationId, onError),
    {
      keepPreviousData: true,
      enabled: !!organizationId,
      ...options,
    }
  );
}
